export enum AssetProcessStatus {
  NotProcessed = 'NotProcessed',
  Processing = 'Processing',
  Processed = 'Processed',
}
